import UserService from "../../api/UserService";

export interface UserState {
    user: {
        authorities: Array<string>,
        user_roles: Array<string>
    }
}

export default {
    namespaced: true,
    state: {
        user: {
            authorities: [],
            user_roles: []
        }
    } as UserState,
    getters: {
        getUser(state: UserState) {
            return state.user;
        },
        getRoles(state: UserState) {
            return state.user.user_roles;
        },
        permissions(state: UserState) {
            return state.user.authorities;
        },
        hasPermission: (state: UserState) => (permission: string) => {
            if (process.env.VUE_APP_NO_SECURITY !== "true") {
                return state.user.authorities.includes(permission);
            } else {
                console.log(`no-sec: granting permission ${permission}`)
                return true;
            }
        }
    },
    mutations: {
        setUser(state: UserState, user: any ){
            state.user = user
        }
    },
    actions: {
        loadUserinfo({ commit, dispatch }: {commit: Function, dispatch: Function}) {
            return UserService.getUserinfo()
                .then(response => {
                    commit("setUser", response);
                })
                .catch(error => {
                    dispatch("snackbar/showMessage", {
                        level: error.level,
                        message: error.message
                    }, { root: true });
                });
        }

    }
}